import React, { useState } from "react";
import { apiGet } from "../lib/api";

export default function DebugApi() {
  const [loading, setLoading] = useState(false);
  const [resp, setResp] = useState<any>(null);

  async function callMe() {
    setLoading(true);
    setResp(null);
    const r = await apiGet<any>("/v1/me");
    setResp(r);
    setLoading(false);
  }

  return (
    <div className="card">
      <h2>API Debug</h2>
      <p className="muted">
        用于验证：/v1 请求是否同源成功（本地由 Vite proxy，线上由 Pages Functions 代理到 API_ORIGIN 或 mock）。
      </p>

      <button onClick={callMe} disabled={loading}>
        {loading ? "Calling…" : "Call /v1/me"}
      </button>

      {resp ? (
        <div className="card">
          <h3>Response</h3>
          <pre>{JSON.stringify(resp, null, 2)}</pre>
          {!resp.ok ? (
            <div className="muted">
              如果是线上真实后端，且你期望 /me 需要登录，那么 401 是正常的。此时至少说明同源代理/网络链路是通的。
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
